import React, { useState } from "react";

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='border-b border-gray-200 bg-white rounded-lg mb-2'>
      <button
        className='flex justify-between items-center w-full p-5 text-left'
        onClick={() => setIsOpen(!isOpen)}>
        <span className='text-lg font-medium text-gray-900'>{question}</span>
        <span
          className={`transform transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}>
          ▼
        </span>
      </button>
      <div
        className={`transition-all duration-200 ease-in-out overflow-hidden ${
          isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}>
        <p className='p-5 text-gray-600'>{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const faqData = [
    {
      question: "How does this platform work?",
      answer:
        "Our platform provides J1 visa holders free access to housing and job listings. You can browse listings, view details, and directly contact landlords or employers through the provided contact information.",
    },
    {
      question: "How can I post a listing?",
      answer:
        "To post a listing, you first need to fill out the application form on our website. Once your application is reviewed and approved by our team, you can log in to create your listings.",
    },
    {
      question: "Is there a fee for posting listings?",
      answer:
        "No, posting listings on our platform is completely free. Our goal is to connect J1 visa holders with landlords and employers in the most efficient way possible.",
    },

    {
      question: "What types of listings can I post?",
      answer:
        "You can post accommodation listings (houses, rooms, apartments, etc.) and job opportunities. All listings must be suitable for J1 visa holders and comply with program requirements.",
    },
    {
      question: "How can I update my listing?",
      answer:
        "After logging in, you can access your 'My Listings' section where you can edit, update, or remove your existing listings.",
    },
    {
      question: "How do I contact listing owners?",
      answer:
        "Each listing's detail page includes contact information (phone, email, etc.) provided by the owner. You can use these details to reach out directly.",
    },

    {
      question: "What are the requirements for employers posting job listings?",
      answer:
        "Employers must provide clear information about the position, including salary, working hours, and any benefits. The job must be suitable for J1 visa holders and comply with program regulations.",
    },
    {
      question: "Are housing listings verified?",
      answer:
        "While we review all listings, we recommend users to thoroughly verify properties and terms before making any commitments. Always meet in safe locations and never send money without proper documentation.",
    },
    {
      question: "Who can I contact for technical support?",
      answer:
        "For technical issues, please email j1listsinfo@gmail.com with details of your problem. Our technical team will assist you as soon as possible.",
    },
  ];

  return (
    <div className='max-w-4xl mx-auto px-4 py-12'>
      <h1 className='text-3xl font-bold text-center mb-4'>
        Frequently Asked Questions
      </h1>
      <p className='text-gray-600 text-center mb-8'>
        Find answers to common questions about our J1 platform
      </p>
      <div className='space-y-4'>
        {faqData.map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
      <div className='mt-12 text-center'>
        <p className='text-gray-600'>
          Have more questions? Contact us at:
          <a
            href='mailto:j1listsinfo@gmail.com'
            className='text-blue-600 ml-2 hover:underline'>
            j1listsinfo@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default FAQ;
